import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../../../assests/css/students/herosection.css";
import { AppContext } from "../../../context/Appcontext";

const HeroSection = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [carouselImages, setCarouselImages] = useState([]);
  const [imageIndex, setImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  // ================= FETCH DATA (Carousel + Events) =================
  const viewAllCarousel = async () => {
    try {
      const [carouselRes, eventsRes] = await Promise.all([
        axios.get(`${baseUrl}/admin/carousel/viewAll`),
        // axios.get(`${baseUrl}/admin/events/viewAllEvents`),
      ]);

      // SAFE CHECK for carousel data
      const carouselData = Array.isArray(carouselRes?.data?.posts)
        ? carouselRes.data.posts
        : [];

      // SAFE CHECK for events data
      const eventsData = Array.isArray(eventsRes?.data?.events)
        ? eventsRes.data.events
        : [];

      // Convert events into the same shape as carousel items
      // Only include events that actually have a hero_image
      const eventsAsCarousel = eventsData
        .filter((ev) => ev?.hero_image)
        .map((ev) => ({
          id: `event-${ev.id}`,
          image: ev.hero_image,
          title: ev.hero_title,
        }));

      // Merge both lists together
      setCarouselImages([...carouselData, ...eventsAsCarousel]);
      setLoading(false);
    } catch (error) {
      console.log("API Error:", error);
      setCarouselImages([]);
      setLoading(false);
    }
  };

  // ================= LOAD API ONCE =================
  useEffect(() => {
    viewAllCarousel();
  }, []);

  // ================= AUTO SLIDER =================
  useEffect(() => {
    if (!carouselImages || carouselImages.length === 0) return;

    const interval = setInterval(() => {
      setImageIndex((prev) => (prev + 1) % carouselImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  return (
    <section className="hs-hero-section">
      <div className="hs-hero-container">
        <div className="hs-hero-row">

          {/* LEFT SIDE */}
          <div className="hs-hero-content">
            <div className="hs-content-wrapper">

              <div className="hs-welcome-badge">
                <span className="hs-badge-icon">🎓</span>
                <span className="hs-badge-text">
                  Welcome to Our College
                </span>
              </div>

              <h1 className="hs-hero-heading">
                {carouselImages.length > 0
                  ? carouselImages[imageIndex]?.title
                  : "Govt Graduate College for Women"}

                <span className="hs-highlight-text">
                  {" "}Gujranwala
                </span>
              </h1>

              <p className="hs-hero-description">
                Build skills with courses, certificates, and degrees online
                from world-class universities and companies.
              </p>

            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="hs-hero-image-section">

            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="hs-carousel-container">

                {carouselImages?.map((item, index) => (
                  <div
                    key={item?.id || index}
                    className={`hs-carousel-item ${
                      index === imageIndex ? "hs-active" : ""
                    }`}
                  >
                    <img
                      className="hs-carousel-image"
                      src={`${baseUrlForFiles}/${item?.image}`}
                      alt={item?.title || "hero"}
                    />
                    <div className="hs-image-overlay"></div>
                  </div>
                ))}

              </div>
            )}

          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;